/* Ouvre le tiroir panier après un ajout, d'où qu'il vienne.

   LE PROBLÈME D'ORIGINE. Horizon a deux boutons « Ajouter au panier » sur une
   fiche produit, et ils ne se comportent pas pareil :

     le bouton principal   type=submit, dans un <product-form-component>,
                           passe par /handleSubmit ;
     la barre collante     type=button, hors du composant, appelle son propre
                           handleAddToCartClick dans sticky-add-to-cart.js.

   Ce handler pose data-puppet="true" sur le vrai bouton avant de le cliquer.
   Le drapeau supprime l'ouverture du tiroir au profit d'une animation de vol
   vers l'icône du panier. Ici cette animation ne joue jamais : elle exige
   .header-actions__cart-icon, que l'en-tête maison ne rend pas. On ajoutait
   donc au panier sans aucun retour visible.

   POURQUOI CE FICHIER NE DISTINGUE PLUS LES DEUX BOUTONS. La première version
   n'ouvrait que sur un clic de la barre collante, pour ne pas ouvrir deux fois
   après le bouton principal. Deux problèmes :

     1. L'ordre. Horizon écoute le clic sur document en capture et s'inscrit
        avant nous, son script chargeant plus tôt. Sa fonction clique le vrai
        bouton dans la même étape de capture, l'ajout part, et
        shopify:cart:lines-update était émis AVANT que notre écouteur soit
        appelé : événement à 6 ms, clic vu à 8 ms. Le drapeau se levait trop
        tard. Déplacer l'écoute sur window l'a réglé, la capture descendant
        window puis document.

     2. Le bouton principal n'ouvre pas toujours le tiroir non plus. Observé
        les deux comportements sur la même page selon l'état. Distinguer les
        deux sources revenait donc à conserver une incohérence.

   On ouvre donc après tout ajout. open() sur un tiroir déjà ouvert ne fait
   rien : il n'y a pas de double ouverture à craindre, et le comportement
   devient le même partout, y compris depuis une carte de collection.

   Le délai de 220 ms laisse Horizon re-rendre la section du tiroir avant qu'on
   l'ouvre, sinon on aperçoit l'ancien contenu un instant. */

(function () {
  if (window.__cvOuvreTiroir) return;
  window.__cvOuvreTiroir = true;

  document.addEventListener(
    'shopify:cart:lines-update',
    function () {
      setTimeout(function () {
        var tiroir = document.getElementById('cart-drawer');
        if (tiroir && typeof tiroir.open === 'function') tiroir.open();
      }, 220);
    },
    true
  );
})();